import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKids = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 135,
	height: 150,
	fill: "none",
	viewBox: "0 0 135 150",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#042536",
			d: "m95.15 102.96-.97-7.74c.77-1.54 4.19-.64 5.8 0l-.96 7.74zm9.57 0-.97-7.74c.77-1.54 4.2-.64 5.8 0l-.96 7.74z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#02405e",
			d: "M125.84 29.8c-1.65-.55-.46 1.82-1.37 4.1-.6 1.37 0 2.05 2.73 2.05 5.95 0 8.2-5.47 6.84-6.83-2.05-1.37-4.1 1.36-6.15 2.05s-.41-.82-2.05-1.37"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6188af",
			d: "M81.54 56.63c-2.73-2.3 4.01-12.2 8.7-16.44 1.34-1.23 16.4-1.53 18.39-.97 8.8 2.5 14.26-8.43 17.68-5.7 6.84 3.65-10.25 13.6-16.4 14.36-2.44.3.99 7.67-2.25 4.88L91.05 58.5l-.8-8.63c-2.9 3.87-5.97 9.07-8.7 6.77"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#040102",
			d: "M94.33 101.51c.02-1.55 3.08-2.13 5.97-1.11 0 0 .7 7.03-1.27 8.93s-3.87-.07-3.87-.07c-.29-1.94-.86-6.2-.83-7.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#040102",
			d: "M100.98 108.4c-.55.53-2.27.92-2.91.91l.04-2.9c.33-.32.99-.95 2.92-.92 1.94.04.94 1.95-.05 2.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#547da7",
			d: "M108.42 53.69c.68-2.71.32-4.2-.97-5.8-.77 0-.97 6.76-.97 10.63.33-.32.97-.97 1.94-4.84"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#9c3147",
			d: "M92.19 53.4c1.83-.62.2-9.57-.97-14.18.67-.4 2.42-1.4 4.04-.42 1.61.98 1.84 10.14 1.75 14.6-2.3.25-6.65.6-4.82 0m14.51-1.6c1.85-.55 0-10.64-1.94-12.58a4.1 4.1 0 0 1 3.87 0c1.64.88 1.06 8.61.97 12.58-2.33.22-4.77.54-2.9 0"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 96.08,
			cy: 50.63,
			fill: "#9c3147",
			rx: 1.74,
			ry: .77
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 99.57,
			cy: 50.63,
			fill: "#9c3147",
			rx: 1.74,
			ry: .77
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#9c3147",
			d: "M94.12 51.8c.1.41-.07-.26-.95-.05s-2.82 1.43-2.92 1.01.09-1.72.97-1.93c.88-.22 2.8.55 2.9.97"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 103.05,
			cy: 50.63,
			fill: "#9c3147",
			rx: 1.74,
			ry: .77
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 106.53,
			cy: 50.63,
			fill: "#9c3147",
			rx: 1.74,
			ry: .77
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#02405e",
			d: "m90.08 52.12 1.1 8.75h18.32c-.98 0 .1-8.1.1-10.04 0 0-7.74-.97-13.55 0-2.35.4-5.97 1.29-5.97 1.29"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#02405e",
			d: "M83.56 91.07c-.82-9.7 4.87-24.83 7.74-31.54h17.4c8.72 7.36 10.65 19.94 11.18 32.97-.53 1.47-3.43 1.47-5.37.5-.96.97-.96 3.88-8.7 4.84-5.8-.96-5.7-3.17-9.67-2.9-3.18.22-3.87.97-8.71.97-2.9 0-3.87-2.9-3.87-4.84"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#9c3147",
			d: "M83.79 90.28v-2.05c2.32.68 6.94 1.23 7.25 1.23 3.08 0 5.98.06 12.17-1.5 4.74-1.2 6.39-.37 9.99 0 .79.08 4.8-.8 6.07-1.34v2.9c-1.05.5-4.44 1.58-6.77.76-5.8-2.05-12.58 1.92-21.46 1.92-3.4 0-6.25-1.23-7.25-1.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#063248",
			strokeLinecap: "round",
			strokeWidth: .37,
			d: "M114.43 93.18c2.43.8 3.77.67 5.05-.18.47-.3.57-.92.37-1.45-.58-1.56-.58-3.3-.58-9.01 0-3.2-1.94-9.67-4.84-15.27M93.15 95.32c-6.17 1.77-7.84-.35-9.26-1.76q-.4-.39-.4-.94a73 73 0 0 1 1.92-15.67c.72-3.12 1.94-8.71 5.8-16.45"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#02151e",
			fillOpacity: .2,
			d: "M90.58 70.97c-.44 17.69 4.1 16.59 1.55 21.18-2.62 4.72-5.24-4.04-1.55-21.18m18.6-3.79c6.63 20.65 1.82 20.43 5.91 25.22 4.22 4.93 3.7-5.97-5.9-25.22"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#02405e",
			d: "M77.49 54.7c-.32 1.02-2.15-.7-3.68-1.18-1.53-.47-3.4-1.67-3.1-2.7.32-1.01 3.5-.47 5.03 0 1.53.48 2.06 2.86 1.75 3.88"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eacdcd",
			d: "M73.8 50.1c.77.75-1.77 1.31-2.9 2.45s-3.2 2.2-3.96 1.45 1-2.76 2.13-3.9 3.98-.75 4.74 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#133c74",
			d: "M23.9 49.74c-1.66-6.3 3.64-18.02 6.5-23.1l2.9 14.25V51l4.8 5.64c-1.85.32-12.54-.58-14.2-6.89"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eacdcd",
			d: "M39.21 26.29c-.44 0-.13-2.54.06-3.72.37.95 5.06.79 7.13 0 .28.98.32 2.18.32 3.13 0 1.18-6.95.59-7.5.59"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#133c74",
			d: "M50.5 24.5c3.23 1.01 8.5 1.06 10.73 13.54 2 11.2 5.02 17.83 7.74 18.38l-7.74.97c-3.27-2.64-4.5-7.53-4.83-10.68-.11 2.82-.13 6.99.96 9.71l-23.14 2.15-1.7-16.4c-.97-5.54-2.33-16.6 0-16.6 2.32 0 12.9 1.99 17.98-1.07"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#02151e",
			fillOpacity: .2,
			d: "m34.22 57.39-.16-.17c-4.56-4.78.14-9.66-1.77-23.04-4.47-4.64-5.1 15.84 1.77 23.04zm-.05-.06"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 36.17 -3.72)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 40.74 34.67)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 36.65 -3.75)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 41.25 34.2)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 37.13 -3.8)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 3.64 38.2)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 37.63 -3.82)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 42.27 33.25)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 35.37 -7.06)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 43.25 30.46)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 35.93 -7.2)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 43.76 30)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 36.35 -7.12)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 7.05 37.4)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 36.9 -7.27)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 44.79 29.05)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 6.32 37.6)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 7.55 36.3)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 6.28 37.1)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 7.05 36.28)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 6.25 36.6)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 6.56 36.25)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 6.3 36)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 6.06 36.22)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 5.56 41.04)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 6.8 39.73)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 5.53 40.54)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 6.3 39.7)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 5.5 40.04)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(-.022 -.9998 -.9999 .0168 45.4 33.2)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 5.46 39.54)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 5.32 39.66)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 35.48 -4.4)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 35.96 -4.44)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 36.45 -4.47)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 36.94 -4.5)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 37.5 -4.65)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 38 -4.68)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 4.87 41.74)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 4.84 41.25)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 4.8 40.75)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 4.77 40.25)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 4.74 39.75)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 4.7 39.25)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 40.77 36.05)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 41.29 35.6)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 41.8 35.1)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 42.3 34.64)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 42.82 34.17)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 4.44 39)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 7.5 39.02)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 7 39)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 6.5 38.97)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 6 38.95)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 5.5 38.93)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 5.02 38.9)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 37.97 -4.2)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 38.4 -4.6)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 36.86 -3.05)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 35.8 -6.12)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 36.3 -6.15)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 35.83 -6.6)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 36.4 -6.75)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 39.5 -5.75)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 39.77 -7.31)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 48 34.6)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 40.26 -7.34)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 48.51 34.13)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 40.83 -7.5)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 7.3 41.89)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 41.23 -7.4)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 7.8 41.91)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 38.97 -10.64)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 50.52 30.4)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 39.53 -10.8)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 51.03 29.93)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 39.95 -10.7)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 51.54 29.46)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 40.5 -10.87)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 52.04 29)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 9.99 41.28)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(-.022 -.9998 -.9999 .0168 51 28.08)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 9.95 40.78)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 10.72 39.94)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 10 40.16)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 10.23 39.92)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 9.89 39.8)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 9.73 39.9)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 9.23 44.72)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 10.47 43.4)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 9.2 44.22)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 9.98 43.37)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 9.16 43.72)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 9.48 43.34)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 9.13 43.22)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 8.99 43.32)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 39.16 -8.1)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 39.56 -8.02)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 40.05 -8.05)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 40.54 -8.09)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 41.03 -8.12)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 41.6 -8.28)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 8.54 45.43)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 8.6 44.8)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 8.56 44.3)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 8.53 43.8)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 8.5 43.3)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 8.45 42.8)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 48.04 35.99)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 48.55 35.52)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 6.62 42.6)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 49.57 34.58)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 50.08 34.1)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 50.6 33.63)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 11.16 42.69)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 10.66 42.66)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 10.17 42.63)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 9.67 42.61)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(-.022 -.9998 -.9999 .0168 51.6 32.7)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 8.68 42.56)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 41.57 -7.8)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 42 -8.18)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 40.46 -6.63)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 39.4 -9.7)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 39.9 -9.73)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 39.5 -10.32)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 40 -10.35)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 43.1 -9.36)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 32.38 -.28)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 33.42 34.39)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 32.95 -.4)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -.37 34.3)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 33.35 -.35)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 .13 34.33)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 33.84 -.38)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 .62 34.36)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 31.58 -3.62)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 35.94 30.18)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 32.06 -3.65)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 36.45 29.7)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 32.55 -3.68)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 36.96 29.24)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 33.04 -3.72)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 37.47 28.77)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 2.8 33.72)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 4.04 32.45)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 2.77 33.22)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 31.8 -3.4)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 2.74 32.73)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 3.05 32.4)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 2.7 32.23)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 2.55 32.37)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 2.05 37.16)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 3.3 35.87)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 2.1 36.56)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 2.8 35.85)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 1.98 36.16)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 2.3 35.83)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 1.95 35.66)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 1.81 35.8)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 31.68 -.97)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 32.17 -1)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 32.66 -1.03)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 33.14 -1.06)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 33.63 -1.1)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 34.2 -1.22)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 1.36 37.87)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 1.33 37.37)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 1.3 36.87)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 1.26 36.37)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 1.23 35.87)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 1.2 35.38)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 33.46 35.77)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -1.06 35)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 34.48 34.83)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 34.99 34.36)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 35.5 33.89)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 .93 35.12)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 3.98 35.17)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 3.49 35.15)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 3 35.12)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 2.5 35.1)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 2 35.07)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 1.5 35.05)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 34.1 -.65)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 34.6 -1.16)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 33.16 .3)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 32.01 -2.68)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 32.5 -2.72)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 32.04 -3.17)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 32.6 -3.3)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 35.63 -2.2)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 41.18 .84)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 41.3 44.34)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 41.66 .8)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 41.8 43.87)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 42.15 .78)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 42.5 .9)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 42.64 .75)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 42.82 42.93)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 40.48 -2.6)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 43.81 40.14)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 40.87 -2.52)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 44.32 39.67)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 41.36 -2.56)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 44.83 39.2)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 41.94 -2.7)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 45.34 38.72)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 1.76 42.6)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 2.9 41.42)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 1.72 42.1)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 2.41 41.4)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 1.69 41.6)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 1.92 41.37)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 1.65 41.1)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 1.42 41.34)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 .9 46.15)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 44 -2)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 .86 45.66)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 1.66 44.83)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 .83 45.16)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 1.17 44.8)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 .8 44.66)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 .68 44.78)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 40.5 .16)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 40.97 .13)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 41.57 0)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 41.94 .06)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 42.43 .03)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 42.92 0)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 .2 46.86)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 .3 46.25)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 .14 45.87)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 .1 45.37)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 .07 44.87)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 .03 44.37)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 41.33 45.72)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 41.84 45.26)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 42.35 44.78)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 42.86 44.31)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -.72 44.1)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 43.88 43.37)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 2.85 44.14)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 2.36 44.12)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 1.86 44.1)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 1.37 44.07)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 .87 44.05)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 .38 44.02)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 43 .37)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 43.4 -.04)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 41.87 1.52)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 40.82 -1.55)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 41.4 -1.7)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 40.84 -2.04)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 41.33 -2.07)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 44.43 -1.07)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 45.08 -3.04)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 49.16 44.27)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 45.67 -3.2)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 49.67 43.8)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 46.06 -3.1)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 46.4 -3)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 46.54 -3.14)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 50.7 42.86)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 44.38 -6.5)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 51.68 40.07)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 44.77 -6.4)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 52.19 39.6)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 45.26 -6.44)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 52.7 39.13)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 45.84 -6.6)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 53.2 38.66)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 5.62 46.71)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 6.88 45.4)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 5.6 46.22)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 6.38 45.37)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 5.56 45.72)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 5.89 45.35)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 5.52 45.22)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 5.4 45.32)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 4.98 50)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 6.13 48.82)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 4.95 49.5)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 5.64 48.8)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 4.91 49)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 5.14 48.77)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 4.87 48.5)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 4.65 48.75)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 44.4 -3.71)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 44.88 -3.75)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 45.47 -3.9)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 45.85 -3.82)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 46.34 -3.85)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 46.83 -3.89)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 4.3 50.71)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 4.14 50.36)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 4.1 49.86)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 4.07 49.36)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 4.04 48.86)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 4 48.37)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 49.2 45.66)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 1.76 48)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 50.22 44.72)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 50.73 44.25)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 51.24 43.78)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 51.75 43.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 6.82 48.11)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 6.32 48.09)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 5.83 48.06)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 5.34 48.04)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 4.84 48.01)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 4.35 47.99)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 46.8 -3.4)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 47.31 -3.92)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 45.9 -2.49)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 44.72 -5.43)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 45.3 -5.6)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 44.74 -5.92)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 45.23 -5.95)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 48.45 -5.1)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 37.1 4.55)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 33.42 44.06)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 37.6 4.52)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 38.4 5.1)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 38.19 4.4)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 34.44 43.12)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 38.57 4.45)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 34.96 42.65)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 36.3 1.22)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -2.4 38.3)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 36.8 1.2)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 36.45 39.38)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 37.28 1.15)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 36.96 38.91)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 37.77 1.12)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 37.64 .8)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -2.14 38.56)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 36.56 .96)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -2.18 38.06)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(-.022 -.9998 -.9999 .0168 35.9 38)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -2.2 37.56)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 36.51 1.93)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -2.24 37.06)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -2.37 37.2)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -2.9 42)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 39.92 1.7)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -2.93 41.5)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 39.9 2.19)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -2.96 41)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 39.87 2.67)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -3 40.5)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -3.1 40.64)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 36.41 3.87)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 37 3.76)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 37.4 3.8)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 37.87 3.78)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 38.36 3.74)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 38.85 3.7)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -3.59 42.7)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -3.5 42.1)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -3.65 41.7)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -3.69 41.2)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -3.6 40.6)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -3.75 40.21)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 33.45 45.45)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -6 39.85)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 34.47 44.5)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 34.99 44.03)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 35.5 43.56)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 36.01 43.09)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -.94 40)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 39.2 1.5)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 39.18 2)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 39.16 2.48)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -2.91 39.9)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 39.1 3.45)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 38.82 4.2)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 39.34 3.67)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 37.8 5.23)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 36.74 2.16)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 37.23 2.12)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 36.77 1.67)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 37.26 1.64)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 40.36 2.64)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 47.52 7.88)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 40.74 57.88)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 48 7.85)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 41.25 57.4)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 48.5 7.82)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 41.76 56.94)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 48.98 7.79)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 42.27 56.46)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 46.72 4.55)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 43.25 53.68)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 47.2 4.51)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 43.76 53.2)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 47.7 4.48)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -4.81 49)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 48.19 4.45)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 44.79 52.26)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -5.55 49.2)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 46.98 4.3)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -5.58 48.7)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(-.022 -.9998 -.9999 .0168 43.2 51.83)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -5.61 48.2)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(-.022 -.9998 -.9999 .0168 42.7 52.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -5.5 47.6)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 46.9 5.75)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -6.3 52.64)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -5 51.34)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -6.34 52.14)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -5.5 51.31)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -6.37 51.64)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 50.3 6)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -6.4 51.15)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 50.28 6.5)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 46.83 7.2)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 47.32 7.17)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 47.8 7.13)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 48.43 7)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 48.78 7.07)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 49.4 6.93)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -7 53.35)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -7.03 52.85)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -6.9 52.23)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -7.1 51.86)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -7.13 51.36)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -7 50.74)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 40.77 59.26)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 41.28 58.8)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 41.8 58.32)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 42.3 57.85)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 42.82 57.38)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 43.33 56.9)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -4.3 50.63)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -4.8 50.6)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 49.6 5.33)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -5.8 50.55)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 49.55 6.3)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -6.78 50.5)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 49.24 7.52)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 49.75 7)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 48.22 8.56)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 47.3 5.38)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 47.65 5.46)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 47.19 5)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 47.8 4.86)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 50.78 5.97)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 51.12 4.3)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 48 57.82)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 51.61 4.26)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 48.52 57.35)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 52.1 4.23)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 49.02 56.87)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 52.59 4.2)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 49.53 56.4)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 50.32 .97)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 50.52 53.6)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 50.8 .93)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 51.03 53.14)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 51.3 .9)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 51.66 1)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 51.79 .87)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 52.05 52.2)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -1.88 52.9)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(-.022 -.9998 -.9999 .0168 51 51.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -1.91 52.4)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 50.56 1.19)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -1.94 51.9)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 50.54 1.68)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -1.98 51.4)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 50.5 2.16)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -2.63 56.33)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -1.33 55)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -2.67 55.83)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 53.92 1.93)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -2.7 55.33)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 53.9 2.41)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -2.59 54.7)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 53.87 2.9)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 50.57 3.5)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 50.92 3.59)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 51.4 3.56)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 51.9 3.52)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 52.38 3.49)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 52.87 3.45)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -3.17 56.9)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -3.2 56.4)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -3.4 56.04)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -3.28 55.4)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -3.31 54.9)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -3.5 54.54)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 48.04 59.2)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 48.55 58.73)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 53.17 5)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 49.58 57.79)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 50.09 57.32)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 50.6 56.85)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -.65 54.3)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(-.022 -.9998 -.9999 .0168 53.13 54.5)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 53.2 1.74)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 53.17 2.23)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(-.022 -.9998 -.9999 .0168 51.6 55.9)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 53.12 3.2)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 52.84 3.94)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 53.5 3.3)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 51.82 4.97)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 50.76 1.9)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 51.25 1.87)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 50.92 1.3)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 51.26 1.4)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 54.38 2.38)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 43.73 11.32)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 33.42 57.6)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 44.36 11.2)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 33.94 57.13)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 44.7 11.25)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 34.45 56.66)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 45.2 11.22)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 34.96 56.19)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 42.93 8)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 35.94 53.4)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 43.42 7.95)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 36.45 52.92)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 43.9 7.92)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 36.96 52.45)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 44.4 7.89)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 37.47 51.98)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -8.9 45.23)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 43.19 7.73)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -9.1 44.83)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(-.022 -.9998 -.9999 .0168 35.9 51.55)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -9.12 44.33)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -8.75 44)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -9.16 43.84)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 43.11 9.18)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -9.81 48.76)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "matrix(-.022 -.9998 -.9999 .0168 39.1 55.19)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -9.7 48.16)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -9 47.45)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -9.88 47.77)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 46.5 9.44)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -9.91 47.27)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .92,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -10 47.4)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 43.04 10.64)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 43.52 10.6)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 44 10.59)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 44.5 10.54)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 44.98 10.5)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 45.47 10.47)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -10.5 49.47)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -10.54 48.97)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -10.57 48.47)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -10.6 47.98)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -10.64 47.48)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(88.74 -10.67 46.98)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 33.46 58.98)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 33.97 58.51)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 34.48 58.04)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 34.99 57.57)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 35.5 57.1)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(.022 .9998 .9999 -.0168 36.01 56.63)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "matrix(-.022 -.9998 -.9999 .0168 39.08 53.8)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -8.3 46.75)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 45.8 8.76)scale(1 -1)skewX(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -9.3 46.7)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -9.8 46.68)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(89.04 -10.3 46.66)scale(-1 1)skewY(.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 45.6 10.87)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 46.1 10.35)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 44.42 12)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 43.5 8.83)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(269.04 44 8.8)skewY(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 43.4 8.44)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 43.88 8.4)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: .46,
			height: .52,
			fill: "#557aac",
			transform: "rotate(-91.26 46.98 9.4)skewX(-.3)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0a1832",
			d: "m35 26 9 24 10.5-24c2.9 0 3.9 2.58 3.7 3.71-.2 1.14-9.46 23.8-9.46 23.8l7.54-.73q.18 0 .25.17c.42 1.33 2.96 9.64 3.81 15.29.6 3.94.75 6.18.9 10.16.14 3.3-.1 5.15 0 8.44A1061 1061 0 0 0 62.28 108l-7.74 1.94c-.97-5.9-2.42-12.68-2.9-17.7-.13-1.33-2.9-11.43-5.33-15.78L43.13 93.4v16.55L33.86 108c-.5-4.7.17-13.97 0-15.77-.6-6.58-.55-27.11-1.57-39.47l5.8.74-7.81-26.1c-.78-1.9 3.67-2.58 4.72-1.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#040102",
			d: "M33.78 102.19c.09-2.27 8.43-2.17 10.14-.65-1.06 8.68-.12 8.9-3.03 13.2-3.64 2.65-7-.64-7-.64-.48-2.87-.2-9.64-.1-11.91"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#040102",
			d: "M44.41 114.1c-.99.81-4.11 1.42-5.3 1.42l-.03-4.27c.58-.47 1.75-1.41 5.29-1.4 3.54 0 1.8 2.84.04 4.26"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M49.57 21.01c-.43 2.1-5.2 4.77-9.39 3.9-4.18-.86-5.8-6.83-5.37-8.92.43-2.1 2.75.48 6.93 1.34 4.19.87 8.26 1.6 7.83 3.68"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#9c3147",
			d: "M50.67 19.87c-2.9 4.84-13.54 4.2-15.48 1.94-5.8-6.77-3.94-19.55.9-20.52C50.66.03 52.34 17.07 50.66 19.87"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#040102",
			d: "M52.6 103.06c-.42-2.23 7.74-4 9.74-2.9.9 8.7 1.87 8.7 0 13.54-2.96 3.4-6.97.95-6.97.95-1.1-2.7-2.34-9.35-2.77-11.59"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#040102",
			d: "M65.41 111.65c-.95.85-4.04 1.6-5.22 1.66l-.25-4.26c.57-.5 1.7-1.5 5.23-1.66s1.93 2.76.24 4.26"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#133c74",
			d: "M68.38 50.5h-1.64c-.24 0-.37.33-.23.53 1.23 1.72.47 5.05.93 5.89q.06.07.16.09c2.44.14 3.35-.36 4.3-1.87a.24.24 0 0 0 0-.27l-3.33-4.28a.2.2 0 0 0-.2-.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#133c74",
			d: "M68 51.59a43 43 0 0 0-4.51-1.83c-.16-.05-.3.06-.24.22.4 1.17 2.12 4.87 2.75 5.43q.07.05.15.03l3.58-.5q.19-.05.2-.25c-.06-.6-.35-2.31-1.93-3.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#efd4d4",
			d: "M97.02 32.45h5.8l1.94 6.77c-3.38 1.05-5.33 1.05-8.7 0 .92-2.28 1.06-3.8.96-6.77"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e9b571",
			d: "M97.11 43.52a6 6 0 0 0 .79 2.19c1.06 2 .77 2.53-.2 1.56-.5-.38-1.11.23-1.94 0-.8-.22-.03-2.8 1.35-3.75q.02-.1.08-.05zm6.76.79c.04.29.27.9.85 2.05 1.03 2.03.13 1.55-.53 1-.15.06-.64.13-1.47-.1-.77-.22.36-1.95 1.14-2.95-.03-.24.06-.25.16-.18z"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 96.23,
			cy: 35.99,
			fill: "#e9b571",
			rx: 2.05,
			ry: 1.78
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e9b571",
			d: "M97.7 37.6c0 1.93-.8 1.93-1.94 1.93-1.13 0-1.58-.8-1.58-1.78s.45-1.6 1.59-1.6c1.13 0 1.93.47 1.93 1.45"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e9b571",
			d: "M97.7 40.5c0 .9-.59 1.98-1.42 1.98s-1.49-1.07-1.49-1.98.66-1.3 1.5-1.3c.82 0 1.4.4 1.4 1.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e9b571",
			d: "M97.7 43.4c0 .9-.32 1.82-1.15 1.82s-1.5-.74-1.5-1.64c-.26-1.64.67-1.64 1.5-1.64s1.15.5 1.15 1.46"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 102.03,
			cy: 35.99,
			fill: "#e9b571",
			rx: 2.05,
			ry: 1.78
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e9b571",
			d: "M104.82 39.04c0 .99-.8.97-1.94.97-1.13 0-1.58-.8-1.58-1.78s.45-1.6 1.59-1.6c1.13 0 1.93 1.43 1.93 2.41"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e9b571",
			d: "M104.82 40.98c0 .9-.58 1.98-1.42 1.98-.83 0-1.48-1.08-1.48-1.98s.65-1.3 1.48-1.3 1.42.4 1.42 1.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e9b571",
			d: "M104.82 43.88c0 .9-.32 1.82-1.15 1.82s-1.5-.74-1.5-1.64c-.25-1.65.67-1.65 1.5-1.65s1.15.5 1.15 1.47m4.4-17.19c0 4.8-5.45 9.8-10.26 9.8a8.7 8.7 0 1 1 0-17.42c4.81 0 10.26 2.81 10.26 7.62"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#9c3147",
			d: "M107.76 27.73c-2.22 5-9.47 8.17-15.82 5.3C84.5 29.25 87.95 13.45 93.4 12c10.26-2.73 17.1 9.57 14.36 15.72"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6188af",
			d: "M74.77 53.73c0 1.93 7.74 4.84 9.68 2.9L82.5 51.8c-2.58 0-7.74-1.94-7.74 1.93"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#040102",
			d: "M104.15 101.43c.03-1.55 4.87-1.85 5.82-.87 0 0-.11 6.77-2.08 8.67s-3.87-.06-3.87-.06c-.29-1.94.1-6.2.13-7.74"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#040102",
			d: "M109.84 108.3c-.56.54-2.28.93-2.92.92l.05-2.9c.33-.32.98-.95 2.92-.92 1.93.03.93 1.95-.05 2.9"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 80.72,
			cy: 146.4,
			fill: "#d4e5fa",
			rx: 2.09,
			ry: 3.37,
			transform: "rotate(-160.22 80.72 146.4)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 95.18,
			cy: 139.97,
			fill: "#d4e5fa",
			rx: 2.09,
			ry: 3.37,
			transform: "rotate(-160.22 95.18 139.97)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 87.44,
			cy: 122.16,
			fill: "#d4e5fa",
			rx: 2.09,
			ry: 3.37,
			transform: "rotate(-160.22 87.44 122.16)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 103.32,
			cy: 121.34,
			fill: "#d4e5fa",
			rx: 2.09,
			ry: 3.37,
			transform: "rotate(-160.22 103.32 121.34)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 2.5,
			cy: 4.05,
			fill: "#d4e5fa",
			rx: 2.5,
			ry: 4.05,
			transform: "rotate(-138.54 52.21 54.2)scale(1 -1)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 2.5,
			cy: 4.05,
			fill: "#d4e5fa",
			rx: 2.5,
			ry: 4.05,
			transform: "rotate(-138.54 43.02 57.55)scale(1 -1)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 2.5,
			cy: 4.05,
			fill: "#d4e5fa",
			rx: 2.5,
			ry: 4.05,
			transform: "rotate(-138.54 47.39 66.72)scale(1 -1)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 2.5,
			cy: 4.05,
			fill: "#d4e5fa",
			rx: 2.5,
			ry: 4.05,
			transform: "rotate(41.46 -190.69 95.6)scale(-1 1)"
		})
	]
});
export default SvgKids;
